export interface ApiCategory {
    id?: string
    name?: string
    numStories?: number
    slug?: string
}

export const getCategoryId = (category: ApiCategory) => category?.id ?? ''

export const getCategoryName = (category: ApiCategory) => category?.name ?? ''

export const getCategorySlug = (category: ApiCategory) => category?.slug ?? "";

export const getNumStories = (category: ApiCategory) => category?.numStories ?? 0

export const parseApiCategory = (category: ApiCategory) => ({
                                    id: getCategoryId(category),
                                    name: getCategoryName(category),
                                    numStories: getNumStories(category),
                                    slug: getCategorySlug(category)
                                });